// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader_loader__P_zZv","circleContainer":"loader_circleContainer__1hc9p","circle":"loader_circle__3wirc"};